import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BaseApiService {
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  constructor(private http: HttpClient) {}

  public get(params: {
    serviceType: string;
    endpoint: string;
    baseUrl?: string;
    options?: { observe: 'response' };
  }): Observable<any> {
    const { serviceType, endpoint } = params;
    return this.http
      .get(`${params?.baseUrl || environment.urlGo}/${serviceType}/${endpoint}`, params?.options)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          switch (error.status) {
            case 404:
              return of(null);
            default:
              return throwError(error);
          }
        })
      );
  }

  public getLaporanGo(params: {
    serviceType: string;
    endpoint: string;
    baseUrl?: string;
    options?: { observe: 'response' };
  }): Observable<any> {
    const { serviceType, endpoint } = params;
    return this.http
      .get(
        `${params?.baseUrl || environment.urlReportingGo}/${serviceType}/${endpoint}`,
        params?.options
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          switch (error.status) {
            case 404:
              return of(null);
            default:
              return throwError(error);
          }
        })
      );
  }

  public post(
    params: {
      serviceType: string;
      endpoint: string;
      baseUrl?: string;
    },
    data: any
  ): Observable<any> {
    const { serviceType, endpoint } = params;
    return this.http
      .post(
        `${params?.baseUrl || environment.urlGo}/${serviceType}/${endpoint}`,
        data,
        this.httpOptions
      )
      .pipe(catchError((err) => throwError(err)));
  }

  public patch(
    params: {
      serviceType: string;
      endpoint: string;
      baseUrl?: string;
    },
    data: any
  ): Observable<any> {
    const { serviceType, endpoint } = params;
    return this.http
      .patch(
        `${params?.baseUrl || environment.urlGo}/${serviceType}/${endpoint}`,
        data,
        this.httpOptions
      )
      .pipe(catchError((err) => throwError(err)));
  }

  public put(
    params: {
      serviceType: string;
      endpoint: string;
      baseUrl?: string;
    },
    data: any
  ): Observable<any> {
    const { serviceType, endpoint } = params;
    return this.http
      .put(
        `${params?.baseUrl || environment.urlGo}/${serviceType}/${endpoint}`,
        data,
        this.httpOptions
      )
      .pipe(catchError((err) => throwError(err)));
  }

  public del(params: { serviceType: string; endpoint: string; baseUrl?: string }): Observable<any> {
    const { serviceType, endpoint } = params;
    return this.http
      .delete(
        `${params?.baseUrl || environment.urlGo}/${serviceType}/${endpoint}`,
        this.httpOptions
      )
      .pipe(catchError((err) => throwError(err)));
  }
}
